// Central store for the auth tokens obtained from the id service code exchange.
// These are Cognito JWTs (same user pool) used as Bearer tokens against the API.
// Replaces the previous Amplify-managed session.

const STORAGE_KEY = "didimo.admin.authTokens";

const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
};

const getTokens = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
};

// Accepts the backend payload shape { id_token, access_token, refresh_token }.
const setTokens = (tokens) => {
    localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
            idToken: tokens.id_token,
            accessToken: tokens.access_token,
            refreshToken: tokens.refresh_token,
        })
    );
};

const clearTokens = () => localStorage.removeItem(STORAGE_KEY);

const getAccessToken = () => getTokens()?.accessToken || null;
const getIdToken = () => getTokens()?.idToken || null;
const getRefreshToken = () => getTokens()?.refreshToken || null;

// True when we hold an access token that has not expired. An optional skew
// (ms) treats a token expiring within that window as already stale, so callers
// can renew proactively before an in-flight request would be rejected.
const isAuthenticated = (skewMs = 0) => {
    const payload = parseJwt(getAccessToken());
    if (!payload?.exp) return false;
    return payload.exp * 1000 > Date.now() + skewMs;
};

const getGroups = () => {
    const payload = parseJwt(getAccessToken());
    return payload?.["cognito:groups"] || [];
};

export default {
    parseJwt,
    getTokens,
    setTokens,
    clearTokens,
    getAccessToken,
    getIdToken,
    getRefreshToken,
    isAuthenticated,
    getGroups,
};
